<div class="dialog-content">
  <p class="dialog-content__msg">{{ config.data.message | translate }}</p>
</div>

<div class="footer">
  <sxw-button (click)="reject()" [label]="config.data.rejectLabel | translate" severity="secondary"></sxw-button>
  <sxw-button
    [styles]="{
      'background-color': config.data.outlined ? 'transparent' : config.data.acceptLabelColor,
      color: config.data.outlined ? config.data.acceptLabelColor : '#fff',
      'border-color': config.data.outlined ? config.data.acceptLabelColor : 'transparent',
    }"
    [label]="config.data.acceptLabel | translate"
    (click)="accept()">
  </sxw-button>
</div>
